// extracted by mini-css-extract-plugin
module.exports = {"nav":"FooterNav_nav_1G2E_","navItem":"FooterNav_navItem_2dw0A"};